export default __webpack_public_path__ + "static/media/visa-logo.0c948ddf.svg";